import { messages as rarumMessages } from './rarum.en'
import openspaceMessages from "openspace/translate/languages/en"
import merge from 'lodash/merge'

const messages = merge(rarumMessages, openspaceMessages)

export { messages }